import React, { useEffect, useState } from "react";
import { LoginModel } from "../../app/models/LoginModel";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "font-awesome/css/font-awesome.min.css";
// import "../../app/layout/styles.css";
//import "../../assets/styles/components/_login.scss";
import BrowserInfoModal from "./BrowserInfoModal";
import LoginBox from "./LoginBox";
import { Navigate, useParams } from "react-router";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react";
import AuthFooter from "./AuthFooter";
import ResetBox from "./ResetBox";
import logo from "../../assets/images/base-login.png";
import ResetTwoFABox from "./ResetTwoFABox";

function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  document.title = "Base - Reset Password";

  return (
    <>
      <div className="login container">
        <div className="row oms-login-box">
          <div className="col-lg-4 col-md-3 col-sm-2"></div>
          <div className="col-lg-4 col-md-6 col-sm-8">
            <div className="tw-m-auto tw-flex tw-items-center tw-justify-center tw-pt-[20%]">
              <img src={logo} alt="Base" className="tw-mb-3 tw-h-[100px]" />
            </div>
            <ResetBox token={token}></ResetBox>
            <br />
            <br />
            <AuthFooter />
          </div>
          <div className="col-lg-4 col-md-3 col-sm-2"></div>
        </div>
      </div>
    </>
  );
}

export default observer(ResetPasswordPage);
